import React from 'react';

import RetryNotification from '../RetryNotification/RetryNotification';

import BankDetails from '@components/BankAccountDetails/BankDetails';
import { useTranslation } from '@hooks/useTranslations';
import { Locale } from '@types-internal';

export type RetryPaymentRivertyBaseProps = {
  orderId: string;
  currency: string;
  siteId: number;
  customerId: string;
  sid?: string;
  amount: number;
  locale: Locale;
  notificationId: string;
  messageKey: string;
  noteKey: string;
  transferKey: string;
  alternativeKey: string;
};

const RetryPaymentRivertyBase: React.FC<RetryPaymentRivertyBaseProps> = ({
  orderId,
  currency,
  siteId,
  customerId,
  sid,
  amount,
  locale,
  notificationId,
  messageKey,
  noteKey,
  transferKey,
  alternativeKey,
}) => {
  const { t, i18n } = useTranslation();
  const formattedAmount = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency,
  }).format(amount || 0);
  return (
    <RetryNotification
      type="warning"
      id={notificationId}
      ariaLabel={t('mzp.order.detail.retry.payment.accessibility.label')}
      currency={currency}
      siteId={siteId}
      customerId={customerId}
      sid={sid}
      orderId={orderId}>
      <div>
        <p className="pp-m-0">
          {t(messageKey)}
          <br />
          {t(noteKey)}
        </p>
        <p>
          <strong>
            {t(transferKey, {
              0: formattedAmount,
              1: orderId,
            })}
          </strong>
        </p>
        <BankDetails />
        <p>{t(alternativeKey)}</p>
      </div>
    </RetryNotification>
  );
};

export default RetryPaymentRivertyBase;
